import { fetchActiveInfo } from "@Services/api";
import { IActiveInfo } from "@Types/campaigns";
import { atom } from "jotai";

const initData = {
  /**
   * 活动状态
   * 0：活动未开始
   * 1：活动中
   * 2：活动已结束
   */
  activityStatus: 0,
  /**
   * 总奖金
   */
  bonusTotal: "",
  /**
   * 规则页链接
   */
  guideLink: "",
  /**
   * 我的活动数据
   */
  me: {
    mId: "",
    /**
     * 会员中心状态显示
     */
    showStatus: 0,
    /**
     * 中奖金额
     */
    bonus: 0,
    /**
     * 回传凭证上传链接
     */
    certLink: "",
    /**
     * 确认书上传链接
     */
    configLink: "",
    /**
     * 过期时间
     */
    expiredAt: "",
    lotteryLink: "",
    /**
     * 活动状态：
     * 10：未询价
     * 11：已询价未回传凭证
     * 20：成交凭证审核中
     * 21：成交凭证审核通过，待抽奖
     * 22：成交凭证审核不通过
     * 23：已抽奖未提交确认书：确认落地页？
     * 24：超时未领取现金
     * 30：中奖确认书审核中
     * 31：中奖确认书审核通过
     * 32：中奖确认书审核不通过
     * 33：中奖确认书超时未重新上传
     */
    status: 0,
  },
  /**
   * 活动名：inquiry-sale
   */
  name: "",
  /**
   * 目前时间
   */
  nowTime: "",
  /**
   * 已获奖金数
   */
  winnerBonus: 0,
};
/** 消息原子 */
export const initActivityAtom = atom<IActiveInfo>(initData);

export const activityAtom = atom(
  (_get) => _get(initActivityAtom),
  async (_get, _set, params = {}) => {
    let res = await fetchActiveInfo(params as any);

    _set(initActivityAtom, res?.data || initData);
  },
);
